<template>
  <div class="outer-box">
    <h4>Logs Search</h4>
    <div class="inner-box" style="text-align: left; width: 620px;">
      <label>Document Type (collection)</label>
    <select
        class="hl_input--wrap"
        type="text"
        v-model="documentType"
      >
        <option value="contacts">Contact</option>
        <option value="opportunities">Opportunity</option>
        <option value="conversations">Conversation</option>
        <option value="campaignstatus">Campaign Status</option>
        <option value="calendarevents">Appointment</option>
        <option value="messages">Message</option>
      </select>
      <label>Document ID</label>
      <input
        class="hl_input--wrap"
        type="text"
        placeholder="JFA8Af9932b08SFJ38snjl"
        v-model="documentId"
      />
      <label>Date reference</label>
      <select
        class="hl_input--wrap"
        type="text"
        v-model="dateReference"
      >
        <option value="date_added">Date added</option>
        <option value="date_updated">Date updated</option>
      </select>
      <label>Date range</label>
      <input class="hl_input--wrap" type="number" placeholder="4" v-model="dateRange" />
      <button class="mt-4 btn btn-primary" @click="formatUrl">Go to logs</button>
    </div>
  </div>
</template>

<script>
import { SpmAppengineService } from '@/services'

export default {
  data() {
    return {
      documentType: "contacts",
      documentId: "",
      dateReference: "date_added",
      dateRange: 4,
      formattedUrl: "",
    };
  },
  methods: {
    async formatUrl() {
        try {
            const { data } = await SpmAppengineService.searchLogs(this.documentId, this.documentType, this.dateRange / 2)
            const dateRangeStart = data[this.dateReference].start;
            const dateRangeEnd = data[this.dateReference].end;
            if (!dateRangeStart || !dateRangeEnd) {
              alert('We were unable to fetch the provided Date Reference for the provided Document ID. Are you sure this Document exists? Please check the Database.')
              return;
            }
            const url = `https://console.cloud.google.com/logs/viewer?project=highlevel-backend&minLogLevel=0&expandAll=false&customFacets=&limitCustomFacetWidth=true&dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}&interval=CUSTOM&resource=gae_app&logName=projects%2Fhighlevel-backend%2Flogs%2Fappengine.googleapis.com%252Frequest_log&logName=projects%2Fhighlevel-backend%2Flogs%2Fbunyan_log&filters=text:${this.documentId}`;
            this.formattedUrl = url;
            window.open(url, '_blank')
        } catch (err) {
            this.$handleError(err)
        }
    },
  },
};
</script>

<style>
.inner-box label {
  margin: 16px auto 0;
  display: inline-block;
}
</style>
